module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAQAAABLCVATAAAAs0lEQVRIx+3Suw2EMBBF0RvSBNRBSIJckyPXQUJCEYRUAm0QzgYY8bHRMhDtyu+Flo5mRoaU96lwOKr3kEMQXIIS9BdQRkMeQDkNmY7pEUaKA1QwIvQaqmRGPLVCCyPMlJpbGE9NtAhCy+QZ8+1254eV2ndjFFBI7RkVdKSOjBLaqDOjhhYqZB5AYCLMIyieH4IsgjDgbnZAEGwI1cE/vtM6NmynZrqrvWvs7dVsfJqU63wAqVLu6wwcsNkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_save.png
// module id = SDwm
// module chunks = 4